<template>
  <div id="header">
    <i v-if="icon"
        :class="iconClass" />
    <h1 class="header-title">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'BaseHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass () {
      switch (this.icon) {
        case 'dashboard':
          return 'fas fa-chart-area'
        case 'order':
          return 'fas fa-paste'
        case 'customer':
          return 'fas fa-user'
        case 'account':
          return 'fas fa-id-card'
        case 'point':
          return 'fas fa-award'
        case 'system':
          return 'fas fa-cog'
        case 'account-setting':
          return 'fas fa-user-circle'
        case 'download':
          return 'fas fa-download'
        case 'stock':
          return 'fas fa-cubes'
        case 'upload':
          return 'fas fa-upload'
        case 'shopping-cart':
          return 'fas fa-shopping-cart'
        case 'fa-share-alt-square':
          return 'fas fa-share-alt-square'
        case 'mailtemplate':
          return 'fas fa-envelope-open-text'
        case 'report':
          return 'fas fa-chart-bar'
        default:
          return ''
      }
    }
  }
}
</script>
